import React, { useCallback, useRef, useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../common/GridLayout";
const ChargesTab = (props) => {
    const dataGrid = useRef(null);
    const gridKey = "64F34A67-BD99-4C50-8C5B-06E2D07D6682";
    var url = "wm/Item/GetCharges";
    const dataSource = useMemo(() => createStore({
        key: 'Rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams:
        {
            id: props.sourceId,
            type : props.type
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        }
    }), [props.sourceId]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                onContentReady={onContentReady}
                dataSource={dataSource}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                height='71vh'
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />

                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column dataField="TransactionType" caption="Trans Type" dataType="string" allowEditing={false} />
                <Column dataField="TransactionDate" caption="Trans Date" dataType="date" format="MM/dd/yyyy hh:mm"  allowEditing={false} />
                <Column dataField="TransactionNumber" caption="Transaction #" dataType="string" allowEditing={false} />
                <Column dataField="ChargeCode" caption="Charge" dataType="string" allowEditing={false} />
                <Column dataField="ChargeTiming" caption="Timing" dataType="string" allowEditing={false} />
                <Column dataField="ChargeReleaseDate" caption="Release" dataType="date" format="MM/dd/yyyy" allowEditing={false} />
                <Column dataField="InvoiceNumber" caption="Invoice Number" dataType="string" allowEditing={false} />
                <Column dataField="QuantityBillAs" caption="BillAs" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={false} />
                <Column
                    dataField="Rate"
                    caption="Rate"
                    dataType="number"
                    format={{
                        type: 'currency',
                        precision: 4,
                        currency: 'USD',
                        useCurrencyAccountingStyle: false // optional, controls symbol placement
                    }}
                    allowEditing={false}
                />

                <Column
                    dataField="Amount"
                    caption="Amount"
                    dataType="number"
                    format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useCurrencyAccountingStyle: false
                    }}
                    allowEditing={false}
                />

                <Column dataField="Fund" caption="Fund" dataType="string" allowEditing={false} />
                <Column dataField="FundDescription" caption="Fund Description" dataType="string" allowEditing={false} />
                <Column dataField="Job" caption="Job" dataType="string" allowEditing={false} />
                <Column dataField="JobDescription" caption="Job Description" dataType="string" allowEditing={false} />
                <Column dataField="Account" caption="Account" dataType="string" allowEditing={false} />
                <Column dataField="AccountDescription" caption="Account Description" dataType="string" allowEditing={false} />
                <Column dataField="Activity" caption="Activity" dataType="string" allowEditing={false} />
                <Column dataField="ActivityDescription" caption="Activity Description" dataType="string" allowEditing={false} />
                <Column dataField="Department" caption="Department" dataType="string" allowEditing={false} />
                <Column dataField="DepartmentDescription" caption="Department Description" dataType="string" allowEditing={false} />
                <Column dataField="Description" caption="Description" dataType="string" allowEditing={false} />
                <Column dataField="TransChargeDescription" caption="Trans Charge Description" dataType="string" allowEditing={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ChargesTab);